<template>
  <v-app id="inspire">
    <v-row
      :class="breakpoint.smAndDown ? 'backgroundMobile' : 'backgroundDesktop'"
      no-gutters
    >
      <v-col :cols="12" :sm="12" :md="12" :lg="12" :xl="12">
        <v-main class="fill-height">
          <v-slide-x-transition mode="out-in">
            <router-view key="content" />
          </v-slide-x-transition>
        </v-main>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
import get from 'lodash.get'

export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      useMock: false,
    }
  },
  computed: {
    breakpoint() {
      return get(this.$vuetify, 'breakpoint', {})
    },
  },
  methods: {
  },
};
</script>

<style lang="sass">
@import '@/sass/custom-theme.sass'

.grecaptcha-badge
  visibility: hidden

.swal2-popup
  font-family: 'Kanit', sans-serif !important
</style>
